import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { Card, CardBody, Container } from 'reactstrap';
import TableContainer from '../../../components/Common/TableContainer';
import { Link, useParams } from 'react-router-dom';
import CoefficiantAbattForm from './CoefficiantAbattForm';
import { useDispatch, useSelector } from 'react-redux';
import { coeffAbattEvActions } from './coeffAbattSlice';

const CoefficiantTable = () => {

  const { t } = useTranslation('translation');

  const { coeffs } = useSelector(state => state.coeffAbattEv);
  const [editingItem, setEditingItem] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    setTimeout(() => {
      dispatch(coeffAbattEvActions.listCoeffAbattEv())
    }, 2000);
  }, [])

  const handleEdit = (item) => {
    setEditingItem(item);
    console.log(item)
  };

  const columns = useMemo(() => [
    {
      Header: t('parametrage.typeEntretien'),
      accessor: 'entretReg',
      disableFilters: true,
      filterable: false,
    },
    {
      Header: t('parametrage.annee1'),
      accessor: 'percentYear1',
      disableFilters: true,
      filterable: false,
    },
    {
      Header: t('parametrage.annee2'),
      accessor: 'percentYear2',
      disableFilters: true,
      filterable: false,
    },
    {
      Header: t('parametrage.annee3'),
      accessor: 'percentFromYear3',
      disableFilters: true,
      filterable: false,
    },
    {
      Header: t('action'),
      accessor: (cellProps) => {
        return (
          <React.Fragment>
            <Link className="me-3 text-primary"
              onClick={() => handleEdit(cellProps)}
            >
              <i className="mdi mdi-pencil font-size-18"></i></Link>
          </React.Fragment>
        )
      },
      disableFilters: true,
      filterable: false,
    },
  ], []);

  return (
    <React.Fragment>
      <div>
        <CoefficiantAbattForm editingItem={editingItem} />
        <TableContainer
          columns={columns || []}
          data={coeffs ?? []}
          isPagination={false}
          isAddParamList={true}
          customPageSizeOptions={true}
          iscustomPageSize={false}
          isBordered={false}
          customPageSize={10}
          canDownloadtemp={true}
          isGlobalFilter={false}
          className="table-primary"

        //handleDownloadTemp={() => downloadTemp()}
        //handleUpload={uploadData}
        />
      </div>
    </React.Fragment>
  )
}

export default CoefficiantTable